package com.essntl.uikit.components.utils

import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.painter.Painter
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.svg.loadSvgPainter
import com.essntl.uikit.resources.LocalRes
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.painterResource

@Composable
fun esIconPainterResource(
    icon: String,
    isSvg: Boolean = false,
): Painter =
    if (isSvg) {
        loadSvgPainter(icon)
    } else {
        painterResource(esIconDrawableResource(icon))
    }

@Composable
fun esImagePainterResource(image: String): Painter = painterResource(esIconDrawableResource(image))

fun esSvgPath(icon: String): String = "files/svg/$icon.svg"

@Composable
fun esIconDrawableResource(icon: String): DrawableResource {
    val res = LocalRes.current

    return when (icon) {
        EsIcons.Logo -> res.logo
        EsIcons.ArrowLeft -> res.arrowLeft
        EsIcons.Person -> res.person
        EsIcons.ArrowIconRight -> res.arrowIconRight
        EsIcons.ArrowIconDown -> res.arrowIconDown
        EsIcons.ArrowUp -> res.arrowUp
        EsIcons.ArrowRight -> res.arrowRight
        EsIcons.ArrowDown -> res.arrowDown
        EsIcons.MoreVertical -> res.moreVertical
        EsIcons.MoreHorizontal -> res.moreHorizontal
        EsIcons.InfoCircle -> res.infoCircle
        EsIcons.CheckCircle -> res.checkCircle
        EsIcons.Check -> res.check
        EsIcons.Drag -> res.drag
        EsIcons.Edit -> res.edit
        EsIcons.Refresh -> res.refresh
        EsIcons.Category -> res.category
        EsIcons.Search -> res.search
        EsIcons.Add -> res.add
        EsIcons.Minus -> res.minus
        EsIcons.Trash -> res.trash
        EsIcons.Timer -> res.timer
        EsIcons.BaseInformation -> res.baseInformation
        EsIcons.Calendar -> res.calendar
        EsIcons.Filter -> res.filter
        EsIcons.Sort -> res.sort
        EsIcons.Service -> res.service
        EsIcons.Itinerary -> res.itinerary
        EsIcons.Concierge -> res.concierge
        EsIcons.Suppliers -> res.suppliers
        EsIcons.Request -> res.request
        EsIcons.NoteFavorite -> res.noteFavorite
        EsIcons.Proposal -> res.proposal
        EsIcons.Task -> res.task
        EsIcons.SpinnerLarge -> res.spinnerLarge
        EsIcons.SpinnerMedium -> res.spinnerMedium
        EsIcons.SpinnerSmall -> res.spinnerSmall
        EsIcons.Close -> res.close
        EsIcons.CloseCircle -> res.closeCircle
        EsIcons.Tick -> res.tick
        EsIcons.Travelers -> res.travelers
        EsIcons.Link -> res.link
        EsIcons.ListBulleted -> res.listBulleted
        EsIcons.ListNumbered -> res.listNumbered
        EsIcons.TextBold -> res.textBold
        EsIcons.TextItalic -> res.textItalic
        EsIcons.TextUnderline -> res.textUnderline
        EsIcons.TextStrikethrough -> res.textStrikethrough
        EsIcons.ColorItem -> res.colorItem
        EsIcons.TextAlignLeft -> res.textAlignLeft
        EsIcons.Copy -> res.copy
        EsIcons.Eye -> res.eye
        EsIcons.Share -> res.share
        EsIcons.EmptyList -> res.emptyList
        EsIcons.EmptySearch -> res.emptySearch
        EsIcons.ContactIcon -> res.contactIcon
        EsIcons.Map -> res.map
        EsIcons.Date -> res.date
        EsIcons.Location -> res.location
        EsIcons.Clients -> res.clients
        EsIcons.BoardIcon -> res.boardIcon
        EsIcons.RequestList -> res.requestList
        EsIcons.ArrowBack -> res.arrowBack
        EsIcons.Crown -> res.crown
        EsIcons.BeLogoFullNude -> res.beLogoFullNude
        EsIcons.DollarSquare -> res.dollarSquare
        EsIcons.Home -> res.home
        EsIcons.Attachment -> res.attachment
        EsIcons.List -> res.list
        EsIcons.Board -> res.board
        EsIcons.Settings -> res.settings
        EsIcons.Star -> res.star
        EsIcons.Mail -> res.mail
        EsIcons.Sms -> res.sms
        EsIcons.Whatsapp -> res.whatsapp
        EsIcons.Arrange -> res.arrange
        EsIcons.FilePicker -> res.filePicker
        EsIcons.EmojiPicker -> res.emojiPicker
        EsIcons.Send -> res.send
        EsIcons.Messages -> res.messages
        EsIcons.DoubleTick -> res.doubleTick
        EsIcons.Menu -> res.menu
        EsIcons.UserAvatar -> res.userAvatar
        EsIcons.Download -> res.download
        EsIcons.Phone -> res.phone
        EsIcons.Group -> res.group
        EsIcons.Expand -> res.expand
        EsIcons.AddSquare -> res.addSquare
        EsIcons.AuthPicture -> res.authPicture
        EsIcons.AuthMobilePicture -> res.authMobilePicture
        EsIcons.Google -> res.google
        EsIcons.Publish -> res.publish
        EsIcons.Browse -> res.browse
        EsIcons.World -> res.world
        else -> throw IllegalArgumentException("Unknown icon: $icon")
    }
}
